import React, { PropsWithChildren } from 'react'
import { createContext } from 'lib/createContext'
import { useUpdateRuleMutation } from 'queries/wage/useUpdateRuleMutation'
import { parseErrorMessage } from 'api'

type EditRuleFlowContextState = {
  state: {
    mutationState: {
      isPending: boolean
      errorMessage: string | undefined
    }
  }
  actions: {
    submit: ReturnType<typeof useUpdateRuleMutation>['mutate']
  }
}

const [Context, useEditRuleFlowContextValue] =
  createContext<EditRuleFlowContextState>({
    name: 'EditRuleFlowContext',
  })

export const EditRuleFlowProvider = ({ children }: PropsWithChildren) => {
  const { mutate, isPending, error } = useUpdateRuleMutation()

  const value: EditRuleFlowContextState = {
    state: {
      mutationState: {
        isPending,
        errorMessage: parseErrorMessage(error),
      },
    },
    actions: { submit: mutate },
  }

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export { useEditRuleFlowContextValue }
